import Vue from 'vue'
import * as types  from '@/vuex/types';
import http from '@/fetch/http'

const state = {
  //页面内容区尺寸
  pageScreenWidth: 0,
  pageScreenHeight: 0,
  //ppt右侧资源slide true 关闭 flase 打开
  pptslideFlag: false,
  resourceTab: 1,
  rightclicktop: null,
  rightclickleft: null,
  //课件ID
  coursewareId: 0,
  //课件
  courseware: {
    pptProp: {},
    page: []
  },
  //例：courseware1:{"pptProp":{},"page":[{"pageProp":{"id":"Step0","rebuild":true,"bgPic":"\resources\files\demo\course_bg.png","translate":{"x":0,"y":0,"z":0},"rotate":{"x":0,"y":0,"z":0}},"pageContent":[{"type":5,"text":"","resource":{"imgSrc":"http://192.168.1.156:9999/resources/1/333666/20171221//5e90f7813cb347858c9e6bdc3a249e21.jpg","iframeSrc":"","resourceId":"29488f6790a749d9afc1d42fe74b4a3c","name":"小青.jpg","other":"img","resourceType":"1"},"selfstyle":{"top":50,"left":0,"z-index":1,"width":228,"height":148}},{"type":1,"text":"123","selfstyle":{"top":157,"left":386,"z-index":1,"width":600,"height":100},"style":"opacity:0","initStyle":"opacity:0","nextStyle":"opacity:1"}]},{"pageProp":{"id":"Step0","rebuild":true,"bgPic":"#FFF","bgColor":"#FFF","translate":{"x":0,"y":0,"z":0},"rotate":{"x":0,"y":0,"z":0}},"pageContent":[{"type":7,"text":"","resource":{"imgSrc":"http://192.168.1.157:8080/xufile/resources/files/flash/flash01.png","iframeSrc":"./static/html/swf.html","resourceId":"1c1d4269938943208f5a20ee0f14d713","name":"这是一个flash","topicnum":"6","other":"pdf"},"selfstyle":{"top":50,"left":0,"z-index":1,"width":600,"height":100},"style":"opacity:0","initStyle":"opacity:0","nextStyle":"opacity:1"}]}]},
  //添加的空白页
  emptyPage: {
    "pageProp": {
      "id": "Step0",
      "rebuild": false,
      "bgPic": "#FFF",
      "translate": {
        "x": 0,
        "y": 0,
        "z": 0
      },
      "rotate": {
        "x": 0,
        "y": 0,
        "z": 0
      }
    },
    "pageContent": []
  },
  //背景图list
  bgList: [
    "#FFF",
    "/resources/files/demo/course_bg.png",
    "/resources/files/demo/1.png",
    "/resources/files/demo/2.png",
    "/resources/files/demo/3.png",
    "/resources/files/demo/dz01.png",
    "/resources/files/demo/dz02.png",
    "/resources/files/demo/dz03.png",
  ],
  //当前页选中的第几个元素
  selectContentIndex:-1,
  //当前激活的UEditor
  ueditorIndex:-1
}

const actions = {
  //页面内容区尺寸
  setpageWidth({commit}, flag){
    commit('setpagewidth', flag)
  },
  setpageHeight({commit}, flag){
    commit('setpageheight', flag)
  },
  setpptslide({commit}, flag) {
    commit('showpptslide', flag)
  },
  setResourceTab({commit}, flag) {
    commit('showresourcetab', flag)
  },
  setTop({commit}, flag) {
    commit('top', flag)
  },
  setLeft({commit}, flag) {
    commit('top', flag)
  },
  //lix
  setCoursewareId({commit}, id){
    commit(types.SET_COURSEWAREID, id)
  },
  setCourseware({commit}, courseware) {
    commit(types.SET_COURSEWARE, courseware)
  },
  addCoursewarePage({commit}, data){
    http.AddCoursewarePage(data.param).then(res => {
      if (res.msgCode == types.STATUS_OK) {
        data.success(data.page);
        data.alert("添加成功");
      } else {
        data.alert("添加失败");
      }
    })
  },
  delCoursewarePage({commit}, data){
    http.DelCoursewarePage(data.param).then(res => {
      console.info(res);
      if (res.msgCode == types.STATUS_OK) {
        console.info('success');
        data.success(data.sort);
      } else {
        console.info('error');
        data.alert("删除失败");
      }
    })
  },
  updateCoursewarePage({commit}, data){
    http.UpdateCoursewarePage(data.param).then(res => {
      if (res.msgCode == types.STATUS_OK) {
        data.alert("保存成功");
      } else {
        data.alert("保存失败");
      }
    })
  },
  findCoursewareInfo({commit}, data){
    http.FindCoursewareInfo(data.param).then(res => {
      if (res.msgCode == types.STATUS_OK) {
        let list = res.data.coursewarePages;
        let courseware = {
          pptProp: {
            id: res.data.id,
            name: res.data.name,
            pageSize: list ? list.length : 0
          },
          page: []
        }
        for (let i = 0; i < courseware.pptProp.pageSize; i++) {
          let newPage = JSON.parse(list[i].content);
          newPage.pageProp.id = list[i].id;
          courseware.page.push(newPage);
        }
        commit('SET_COURSEWARE', courseware);
        if(data.success){
          data.success();
        }
      }
    })
  },
  findGivingCwInfo({commit}, data){
    http.selectGivingCwInfo(data.param).then(res => {
      if (res.msgCode == types.STATUS_OK) {
        let list = res.data.coursewarePages;
        let courseware = {
          pptProp: {
            id: res.data.id,
            name: res.data.name,
            pageSize: list ? list.length : 0
          },
          page: []
        }
        for (let i = 0; i < courseware.pptProp.pageSize; i++) {
          let newPage = JSON.parse(list[i].content);
          newPage.pageProp.id = list[i].id;
          courseware.page.push(newPage);
        }
        commit('SET_COURSEWARE', courseware);
        if(data.success){
          data.success();
        }
      }
    })
  },
  setSelectContentIndex({commit}, index){
    commit('SET_SELECT_CONTENT_INDEX',index);
  },
  setUeditorIndex({commit}, index){
    commit('SET_UEDITOR_INDEX',index);
  }


}

const mutations = {
  //页面内容区尺寸
  setpagewidth(state, flag){
    state.pageScreenWidth = flag;
  },
  setpageheight(state, flag){
    state.pageScreenHeight = flag;
  },
  showpptslide(state, flag) {
    state.pptslideFlag = !state.pptslideFlag;
  },
  showresourcetab(state, flag) {
    //flag 1 资源 2 动画 3 背景 4 习题
    state.resourceTab = flag;
  },
  top(state, flag) {
    state.rightclicktop = flag;
  },
  left(state, flag) {
    state.rightclickleft = flag;
  },
  [types.SET_COURSEWAREID](state, id){
    Vue.set(state, "coursewareId", id);
  },
  [types.SET_COURSEWARE](state, courseware){
    Vue.set(state, 'courseware', courseware);
  },
  'SET_SELECT_CONTENT_INDEX'(state,index){
    Vue.set(state,'selectContentIndex',index);
  },
  'SET_UEDITOR_INDEX'(state,index){
    Vue.set(state,'ueditorIndex',index);
  }


}
const getters = {}

export default {
  state,
  actions,
  mutations,
  getters
}



// WEBPACK FOOTER //
// ./src/vuex/ppt/pptstatus.js